import { GetCustomerByIdentifier } from "../queries/GetCustomerByIdentifier.core.js";
export const getCustomerByIdentifier = async ({ customerIdentifier }, { client }) => {
    const data = await client.core.request(GetCustomerByIdentifier, {
        customerIdentifier,
    });
    if (!data?.customer) {
        return null;
    }
    if (data.customer.__typename == "UnknownError") {
        throw new Error(`Error getting customer by identifier: ${customerIdentifier}. ErrorName: ${data.customer.errorName}. Message: ${data.customer.message}`);
    }
    if (data.customer.__typename !== "Customer") {
        throw new Error(`Error getting customer by identifier: ${customerIdentifier}. Unexpected typename: ${data.customer.__typename}`);
    }
    return data.customer;
};
